import React, { useEffect, useState } from 'react'
import Loaders from '../../../components/loaders/Loaders'
import { Helmet } from 'react-helmet-async'
import BreadCrumb from '../../../components/breadcrumb/BreadCrumb'
import { BreadCrumRoutes } from '../../../helpers/helpers'
import { deleteStudentNotifications, getAllNotifications, getReadNotifications, getUnReadNotifications, updateStudentNotificationRead } from '../../../service/student/student.service'
import { FaDotCircle, FaExclamation, FaInfoCircle } from 'react-icons/fa'
import Pagination from '../../../components/paginations/Pagination'
import moment from 'moment'

export default function StudentNotifiactions() {
    const [pageLoading, setPageLoading] = useState(false)
    const [loading, setLoading] = useState(false)
      const [breadCrumData, setBreadCrumData] = useState<any>();
      const [unreadNotifications, setUnreadNotifications] = useState<any>([])
      const [readNotifications, setReadNotifications] = useState<any>([])
      const [allNotifications, setAllNotifications] = useState<any>([])
      const [unreadPage, setUnreadPage] = useState(1);
      const [readPage, setReadPage] = useState(1);
      const [allPage, setAllPage] = useState(1);
    const [activeTab, setActiveTab] = useState(0)
      const tabs = ["Unread", "Read","All"] 
     
      const fetchAllNotifications = async(page?:number)=>{
        let pages = page || 1;
        setLoading(true)
        const get:any = await getAllNotifications(pages);
        if(get?.status === "success"){
            setAllNotifications(get?.message);
            
        }
        setLoading(false)
      }
      const fetchUnreadNotifications = async(page?:number)=>{
        setLoading(true)
        let pages = page || 1;
        const get:any = await getUnReadNotifications(pages);
        if(get?.status === "success"){
            setUnreadNotifications(get?.message);
            
        }
        setLoading(false)
      }
      const fetchReadNotifications = async(page?:number)=>{
        setLoading(true)
        let pages = page || 1;
        const get:any = await getReadNotifications(pages);
        if(get?.status === "success"){
            setReadNotifications(get?.message);
            
        }
        setLoading(false)
      }

      useEffect(()=>{
        fetchUnreadNotifications();
         setBreadCrumData(
              BreadCrumRoutes(
                'Notifications',
                '/student/notifications',
                'studentLiveClass',
                true
              )
            );
      },[])
      const handleTabChange = (tab:number)=>{
        setActiveTab(tab)
        if(tab === 0){
            fetchUnreadNotifications()
        }else if(tab === 1){
            fetchReadNotifications()
        }else if(tab === 2){
            fetchAllNotifications()
        }
      }
      const handleNotificationsDelete = async(id:string)=>{
            let del:any = await deleteStudentNotifications(id);
            if(del?.status === "success"){
                if(activeTab === 0){
                    let mod:any = unreadNotifications?.data?.filter((item:any)=>item.id !== id);
                    setUnreadNotifications({
                        data: mod,
                        totalPage: unreadNotifications?.totalPage,
                        totalRow: unreadNotifications?.totalRow-1,
                    })
                }else if(activeTab === 1){
                    let mod:any = readNotifications?.data?.filter((item:any)=>item.id !== id);
                    setReadNotifications({
                        data: mod,
                        totalPage: readNotifications?.totalPage,
                        totalRow: readNotifications?.totalRow-1,
                        
                    })
                }
                else if(activeTab === 2){
                    let mod:any = allNotifications?.data?.filter((item:any)=>item.id !== id);
                    setAllNotifications({
                        data: mod,
                        totalPage: allNotifications?.totalPage,
                        totalRow: allNotifications?.totalRow-1,
                    })
                }
            }
      }
      const handlePageChange = (page: number) => {
        
        if(activeTab === 0){
            fetchUnreadNotifications(page)
            setUnreadPage(page)
        }else if(activeTab === 1){
            fetchReadNotifications(page)
            setReadPage(page)
        }else if(activeTab === 2){
            fetchAllNotifications(page)
            setAllPage(page)
        }
      };
      const handleMarkasRead = async(id:string)=>{
        const fetch:any = await updateStudentNotificationRead(id);
        if(fetch?.status === "success"){
            let mod:any = unreadNotifications?.data?.filter((item:any)=>item.id !== id);
            setUnreadNotifications({
                data: mod,
                totalPage: unreadNotifications?.totalPage,
                totalRow: unreadNotifications?.totalRow-1,
            })
        }
      }
      return (
    pageLoading  ?
    <Loaders type='spinner' />
    :
    <>
         <Helmet>
                <title>{`Notifications | ${window.location.hostname}`}</title>
        </Helmet>
          <BreadCrumb routes={breadCrumData} />
       <div className='flex justify-start items-center gap-2 overflow-auto'>
         {
            tabs.map((tab, index) => (
              <button
                key={index}
                className={` ${activeTab === index? 'bg-purple-700 text-white': ' bg-purple-400 text-gray-100'} py-2 px-4 rounded-xl  `}
                onClick={() => handleTabChange(index)}
              >
                {tab}
              </button>
            ))}
       </div>
            <hr className='mb-3 mt-1 text-gray-900 bg-gray-900 h-[2px]' />
            <div className='my-2'>
            {/* Unread Notifications */}
            {activeTab === 0 && (
              loading ? <Loaders type="spinner" /> :
              unreadNotifications?.data?.length > 0 ? (
                <>
                  {unreadNotifications?.data?.map((item: any, index: number) => (
                    <div key={index} className='flex my-2 justify-between border rounded-xl p-2'>
                      <div className='flex gap-2 items-center'>
                        {item?.category === "subscription" ? (
                          <FaInfoCircle className='text-3xl text-yellow-700' />
                        ) : (
                          <FaDotCircle className='text-3xl' />
                        )}
                        <div>
                          <p className='text-md font-semibold'>{item?.category}</p>
                          <p className='text-sm'>{item?.notification}</p>
                        </div>
                      </div>
                      <div className='flex items-center gap-2'>
                        <p className='mx-3'>{moment(item?.createAt).format("DD MMM YYYY")}</p>
                        <button onClick={() => handleMarkasRead(item?.id)} className='px-4 py-2 rounded-xl bg-gray-600 text-gray-100'>Mark as Read</button>
                        <button onClick={() => handleNotificationsDelete(item?.id)} className='px-4 py-2 rounded-xl bg-red-600 text-gray-100'>Delete</button>
                      </div>
                    </div>
                  ))}
                  <div className="pb-5 flex justify-end">
                    <Pagination 
                      currentPage={unreadPage} 
                      totalPages={unreadNotifications?.totalPage || 1} 
                      onPageChange={handlePageChange} 
                    />
                  </div>
                </>
              ) : <p>No new notifications</p>
            )}
        
            {/* Read Notifications */}
            {activeTab === 1 && (
              loading ? <Loaders type="spinner" /> :
              readNotifications?.data?.length > 0 ? (
                <>
                  {readNotifications?.data?.map((item: any, index: number) => (
                    <div key={index} className='flex my-2 justify-between border rounded-xl p-2'>
                      <div className='flex gap-2 items-center'>
                        {item?.category === "subscription" ? (
                          <FaInfoCircle className='text-3xl text-yellow-700' />
                        ) : (
                          <FaDotCircle className='text-3xl' />
                        )}
                        <div>
                          <p className='text-md font-semibold'>{item?.category}</p>
                          <p className='text-sm'>{item?.notification}</p>
                        </div>
                      </div>
                      <div className='flex items-center gap-2'>
                        <p className='mx-3'>{moment(item?.createAt).format("DD MMM YYYY")}</p>
                        <button onClick={() => handleNotificationsDelete(item?.id)} className='px-4 py-2 rounded-xl bg-red-600 text-gray-100'>Delete</button>
                      </div>
                    </div>
                  ))}
                  <div className="pb-5 flex justify-end">
                    <Pagination 
                      currentPage={readPage} 
                      totalPages={readNotifications?.totalPage || 1} 
                      onPageChange={handlePageChange} 
                    />
                  </div>
                </>
              ) : <p>No read notifications</p>
            )}
        
            {/* All Notifications */}
            {activeTab === 2 && (
              loading ? <Loaders type="spinner" /> :
              allNotifications?.data?.length > 0 ? (
                <>
                  {allNotifications?.data?.map((item: any, index: number) => (
                    <div key={index} className='flex my-2 justify-between border rounded-xl p-2'>
                      <div className='flex gap-2 items-center'>
                        {item?.category === "subscription" ? (
                          <FaInfoCircle className='text-3xl text-yellow-700' />
                        ) : (
                          <FaDotCircle className='text-3xl' />
                        )}
                        <div>
                          <p className='text-md font-semibold'>{item?.category}</p>
                          <p className='text-sm'>{item?.notification}</p>
                        </div>
                      </div>
                      <div className='flex items-center gap-2'>
                        <p className='mx-3'>{moment(item?.createAt).format("DD MMM YYYY")}</p>
                        <button onClick={() => handleNotificationsDelete(item?.id)} className='px-4 py-2 rounded-xl bg-red-600 text-gray-100'>Delete</button>
                      </div>
                    </div>
                  ))}
                  <div className="pb-5 flex justify-end">
                    <Pagination 
                      currentPage={allPage} 
                      totalPages={allNotifications?.totalPage || 1} 
                      onPageChange={handlePageChange} 
                    />
                  </div>
                </>
              ) : <p>No notifications found</p>
            )}
          </div>

    </>
  )
}
